import {Box, Button, Form, FormField, Heading, Layer, RadioButtonGroup, TextInput} from "grommet";
import { PARTNERS_GROUP_FEE, PARTNERS_GROUP_STRATEGY } from "./SavingIzp";

const PartnerInvestmentProductForm = ({onClose, values, setForm, onSubmit}) => {

	return (
		<Layer onEsc={() => onClose(false)} onClickOutside={() => onClose(false)} >
			<Box pad="medium">
				<Form
					value={values}
					onChange={nextValue => {					
						setForm(nextValue);
					}}
					onSubmit={({ value }) => onSubmit(value) }
				>
                    <Heading level="3" margin={{top: "none"}}>Nastavenie parametrov</Heading>

                    <Box direction={'row-responsive'}>
                        <Box basis={'auto'} round={'xsmall'} margin={{bottom: 'large', top:'medium'}}>
                        <FormField label="Typ poplatku" width={'full'}>
                            <RadioButtonGroup direction={'row'} gap={'medium'} name="fee" options={PARTNERS_GROUP_FEE.map(function(v){
                                return {value: v.id, label: v.label}
                            })} />
                            </FormField>
                        </Box>
                    </Box>

                    <Box direction={'row-responsive'}>
                        <Box basis={'auto'} round={'xsmall'} margin={{bottom: 'large', top:'medium'}}>
                            <FormField label="Stratégia" width={'full'}>
                                <RadioButtonGroup direction={'row'} gap={'medium'} name="strategy" options={PARTNERS_GROUP_STRATEGY.map(function(v){
                                    return {value: v.id, label: v.label}
                                })} />
                            </FormField>
                        </Box>
                    </Box>

					<Box direction="row" gap="medium" margin={{top:'large'}}>
						<Button type="submit" primary label="Pridať" />
						<Button onClick={() => onClose(false)} label="Zavrieť" />
					</Box>
				</Form>
			</Box>
		</Layer>)
}

export default PartnerInvestmentProductForm;